import { useContext } from 'react';
import RightDrawerContext from '../contexts/RightDrawerContext';

export const useRightDrawerDispatcher = () => {
  const { showRightDrawer, hideRightDrawer } = useContext(RightDrawerContext);
  return { showRightDrawer, hideRightDrawer };
};
